import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const GiftIcon = () => <FontAwesomeIcon icon={["fas", "gift"]}/>

export default GiftIcon;

